import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import { useCallback, useState } from 'react'

import { fail } from 'onboarding/classes/services/notification'
import { specializationEligibilityCriteriaService } from 'onboarding/services/specializationEligibilityCriteriaService'

import { TRevenueCriteriaThresholds, TSpecializationEligibilityCriteriaWithName } from '../models'

export const useActiveSpecializationCriteriaHandlers = () => {
  const [specializationCriteria, setSpecializationCriteria] =
    useState<TSpecializationEligibilityCriteriaWithName | null>(null)
  const [revenueCriteriaThresholds, setRevenueCriteriaThresholds] =
    useState<TRevenueCriteriaThresholds | null>(null)
  const [isSpecializationCriteriaLoading, setIsSpecializationCriteriaLoading] = useState(false)
  const [isRevenueCriteriaLoading, setIsRevenueCriteriaLoading] = useState(false)

  const fetchSpecializationCriteria = useCallback(
    async (code: string, requestType: RequestTypes) => {
      try {
        setIsSpecializationCriteriaLoading(true)
        const specializationCriteria =
          await specializationEligibilityCriteriaService.fetchActiveByCodeAndTypeExtended(
            code,
            requestType
          )
        setSpecializationCriteria(specializationCriteria)
      } catch (e: any) {
        fail(e.message || 'Failed to find active specialization criteria')
        setSpecializationCriteria(null)
      } finally {
        setIsSpecializationCriteriaLoading(false)
      }
    },
    []
  )

  const fetchRevenueCriteria = useCallback(async (code: string, countryISO: string) => {
    try {
      setIsRevenueCriteriaLoading(true)
      const revenueCriteriaThresholds =
        await specializationEligibilityCriteriaService.fetchRevenueCriteriaThresholds(
          code,
          countryISO
        )
      setRevenueCriteriaThresholds(revenueCriteriaThresholds)
    } catch (e: any) {
      fail(e.message || 'Failed to find revenue criteria thresholds')
      setRevenueCriteriaThresholds(null)
    } finally {
      setIsRevenueCriteriaLoading(false)
    }
  }, [])

  const resetSpecializationCriteria = useCallback(() => {
    setSpecializationCriteria(null)
  }, [])
  const resetRevenueCriteriaThresholds = useCallback(() => {
    setRevenueCriteriaThresholds(null)
  }, [])

  return {
    fetchSpecializationCriteria,
    fetchRevenueCriteria,
    resetSpecializationCriteria,
    resetRevenueCriteriaThresholds,
    specializationCriteria,
    revenueCriteriaThresholds,
    isSpecializationCriteriaLoading,
    isRevenueCriteriaLoading,
  }
}
